import React from 'react';

// Calcite
import Panel from "calcite-react/Panel";
import Popover from 'calcite-react/Popover';
import Tooltip from "calcite-react/Tooltip";

// Calcite Icons
import DownloadToIcon from 'calcite-ui-icons-react/DownloadToIcon';
import WebIcon from 'calcite-ui-icons-react/WebIcon';
import QuestionIcon from "calcite-ui-icons-react/QuestionFIcon";


// components.main.Events
import { makeIcsInfo } from '../components/main/Events/ics';

// context
import Context from '../context/Context';

// util
import { addToCalendar, removeFromCalendar, updateInCalendar, CALENDAR_TYPES } from './calendarUtil';

const CSS = {
  main: "i-calendar-selector",
  logo: "i-calendar-logo",
  logoGoogle: "i-calendar-logo--google",
  logoOutlook: "i-calendar-logo--outlook",
  genericButton: "i-generic-button"
};

export default class CalendarSelector extends React.Component {

  icsInfo;
  // constructor(props) {
  //   super(props);

  //   // this.state = {
  //   //   icsInfo: null
  //   // };
  // }

  componentDidMount() {
    const promise = this.props.params;
    promise.then((params)=> {
      const { eventICS } = params;

      if (!eventICS) {
        return;
      }
      const { info, filename } = eventICS;
      this.updateICSInfo(info, filename);
    })
  }

  async updateICSInfo(info, filename) {

    let bookingOperation;
    if (this.props && this.props.removeBooking) bookingOperation = "removeBooking";
    else if (this.props && this.props.updateBooking) bookingOperation = "updateBooking";
    else bookingOperation = "addBooking";

    const icsInfo = await makeIcsInfo(info, filename, bookingOperation);
    this.icsInfo = icsInfo;
  }

  render() {
    const { onRequestClose, open, targetEl } = this.props;
    if (this.props && this.props._updateICSfile) {
      const promise = this.props.params;
      promise.then((params)=> {
        const { eventICS } = params;
  
        if (!eventICS) {
          return;
        }
        const { info, filename } = eventICS;
        this.updateICSInfo(info, filename);
      })
    }
    return (
      <Popover
        onRequestClose={onRequestClose}
        open={open}
        targetEl={targetEl}
        appendToBody
      >
        <Panel white>
          {this.renderContent()}
        </Panel>
      </Popover>
    );
  }

  renderContent() {
    let items = [];
    const workspaceReservation = Context.instance.config.workspaceReservation;
    const google = typeof workspaceReservation.enableGoogleCalendar == 'boolean' ? workspaceReservation.enableGoogleCalendar : null;

    if(google && this.props.updateBooking) items.push(this.renderGoogle("addGoogleBkg"));
    items.push(Object.keys(CALENDAR_TYPES).map((key) => this.renderOption(CALENDAR_TYPES[key])));

    return (
      <div className={CSS.main}>
        <ul>
          {items}
        </ul>
      </div>
    );
  }

  renderOption(type) {
    const workspaceReservation = Context.instance.config.workspaceReservation;
    const google = workspaceReservation.enableGoogleCalendar;
    const outlook = workspaceReservation.enableOutlookCalendar;
    switch(type) {
      case CALENDAR_TYPES.google:
        if (!google) return null;
        else return this.renderGoogle();
      case CALENDAR_TYPES.outlookApp:
        if (!outlook) return null;
        else return this.renderOutlookApp();
      case CALENDAR_TYPES.outlookOnline:
        if (!outlook) return null;
        else return this.renderOutlookOnline();
      case CALENDAR_TYPES.generic:
        return this.renderGeneric();
      default:
        return null;
    }
  }

  onClick = (event, info) => {
    event.stopPropagation();
    const type = event.target.getAttribute("data-caltype");
    const promise = this.props.params;
    promise.then((params)=> {
      if (type) {
        if(this.props && this.props.removeBooking) removeFromCalendar(type, params);
        else if (this.props && this.props.updateBooking) {
          const origResAttr = this.props && this.props.origResAttr;
          if (info && info === "addGoogleBkg") {
            addToCalendar(type, params);
          }
          else updateInCalendar(type, params, origResAttr);
        }
        else addToCalendar(type, params);
      }
    })
    const { onRequestClose } = this.props; 
    if (typeof onRequestClose === "function") {
      onRequestClose();
    }
  }

  renderGoogle(info) {
    const i18n = Context.getInstance().i18n;
    const isRemoveBkg = this.props && this.props.removeBooking;
    const isUpdateBkg = this.props && this.props.updateBooking
    const isRtl = Context.instance.uiMode.isRtl;
    const qstyle = {
      marginTop: "0.8rem",
      fill: "#6e6e6e"
    }

    if (isRtl) qstyle.marginRight = "0.5rem"
    else qstyle.marginLeft = "0.5rem"

    let textAlign = "left";
    if(isRtl) textAlign = "right"

    let title = i18n.calendars.google;
    let infoTitle = i18n.calendars.googleInfoUpdate;
    if (isUpdateBkg) {
      title = i18n.calendars.googleUpdate;
      if (info === "addGoogleBkg") {
        title = i18n.calendars.googleNew;
        infoTitle = i18n.calendars.googleInfoAdd;
      }
    }
   
    return (
      <li key={CALENDAR_TYPES.google} className="i-calendar-tooltip" style={{display: "flex"}}>
        <button 
          data-caltype={"google"}
          onClick={(event)=>this.onClick(event,info)}>
          <img 
            data-caltype={"google"}
            className={CSS.logoGoogle} 
            src="assets/Google.png"
            alt={i18n.general.image} 
          />
          <h3 data-caltype={"google"}>{title}</h3>
        </button>
        {isRemoveBkg &&
            <Tooltip style={{textAlign: textAlign}} title={i18n.calendars.googleInfo}>
              <QuestionIcon size="16" style={qstyle}/>
          </Tooltip>
        }
        {isUpdateBkg && 
            <Tooltip style={{textAlign: textAlign}} title={infoTitle}>
              <QuestionIcon size="16" style={qstyle}/>
          </Tooltip>
        }
      </li>
    );
  }

  renderOutlookApp() {
    const i18n = Context.getInstance().i18n;
    const isRemoveBkg = this.props && this.props.removeBooking;
    const isUpdateBkg = this.props && this.props.updateBooking
    const isRtl = Context.instance.uiMode.isRtl;
    const qstyle = {
      marginTop: "0.8rem",
      fill: "#6e6e6e"
    }
    
    if (isRtl) qstyle.marginRight = "0.5rem"
    else qstyle.marginLeft = "0.5rem"

    let textAlign = "left";
    if(isRtl) textAlign = "right"

    // const { icsInfo } = this.state;
    // console.log("ics info", icsInfo)
    if (!this.icsInfo) {
      return null;
    }

    return (
      <li key={CALENDAR_TYPES.outlookApp} className="i-calendar-tooltip" style={{display: 'flex'}}>
        <a 
          onClick={this.onClick}
          href={this.icsInfo.href} 
          role="button"
          download={this.icsInfo.filename} 
          rel="noopener noreferrer" 
          target="_blank"
        >
          <img 
            data-caltype={"outlook-app"}
            className={CSS.logoOutlook} 
            src="assets/Outlook_64x64.svg"
            alt={i18n.general.image} 
          />
          <h3 data-caltype={"outlook-app"}>{i18n.calendars.outlookApp}</h3>
        </a>
          {isRemoveBkg && 
            <Tooltip style={{textAlign: textAlign}} title={i18n.calendars.outlookInfo}>
              <QuestionIcon size="16" style={qstyle}/>
            </Tooltip>}
          {isUpdateBkg && 
            <Tooltip style={{textAlign: textAlign}} title={i18n.calendars.outlookInfoUpdate}>
              <QuestionIcon size="16" style={qstyle}/>
          </Tooltip>}
      </li>
    );
  }

  renderOutlookOnline() {
    const i18n = Context.getInstance().i18n;

    return (
      <li key={CALENDAR_TYPES.outlookOnline}>
        <button 
          data-caltype={"outlook-online"}
          onClick={this.onClick}
        >
          <img 
            data-caltype={"outlook-online"}
            className={CSS.logoOutlook} 
            src="assets/Outlook_64x64.svg"
            alt={i18n.general.image} 
          />
          <h3 data-caltype={"outlook-online"}>{i18n.calendars.outlookOnline}</h3>
          <WebIcon />
        </button>
      </li>
    );
  }

  renderGeneric() {
    const i18n = Context.getInstance().i18n;

    if (!this.icsInfo) {
      return null;
    }

    return (
      <li key={CALENDAR_TYPES.generic} style={{marginInlineEnd:'auto'}}>
        <a 
          className={CSS.genericButton}
          onClick={this.onClick}
          href={this.icsInfo.href} 
          role="button"
          download={this.icsInfo.filename} 
          rel="noopener noreferrer" 
          target="_blank"
        >
          <DownloadToIcon data-caltype={"generic"} />
          <h3 data-caltype={"generic"}>{i18n.calendars.generic}</h3>
        </a>
      </li>
    );
  }
}